<template>
  <!-- Cabeçalho mobile ESTÁTICO (pedido): sem a classe "sticky-top" do
       Bootstrap, então não fica mais fixo no topo ao rolar a página -
       rola junto com o conteúdo. O cabeçalho desktop mantém seu próprio
       comportamento (barra fixa ao rolar) inalterado. -->
  <header id="header" class="header-mobile-- header dark-background">
    <ModalCategoriaFiltroMobile />
    <!-- Top Bar -->

    <!-- Main Header -->
    <div class="main-header" id="header-main-">
      <div class="mr-4 ml-4">
        <div
          style="margin-left: -16px !important; margin-right: -16px !important"
          class="d-flex align-items-center justify-content-between mobile-header-row"
        >
          <!-- Grupo esquerdo: hambúrguer (categorias) + Institucional -
               ambos como botões de ícone, do mesmo tamanho dos botões de
               login/carrinho do lado direito, para equilibrar visualmente
               a linha com a logomarca centralizada no meio. -->
          <div class="mobile-header-left">
            <a
              class="header-action-btn button-header-action-- text-muted mobile-header-btn"
              @click="$bvModal.show('categorias-filtro-global')"
              aria-label="Categorias"
            >
              <b-icon-list></b-icon-list>
            </a>

            <a
              class="header-action-btn button-header-action-- text-muted mobile-header-btn"
              @click="$bvModal.show('opcoes-institucionais')"
              aria-label="Institucional"
            >
              <i class="bi bi-info-circle"></i>
            </a>
          </div>

          <a href="/" class="logo d-flex align-items-center mobile-header-logo">
            <!-- Uncomment the line below if you also wish to use an image logo -->
            <!-- <img srcexample3.png" alt=""> -->
            <h1 class="sitename">
              <mx3-logo />
            </h1>
          </a>

          <ModalOpcaoInstitucional />

          <!-- Search -->

          <!-- Navigation -->
          <div class="header-nav">
            <div class="position-relative">
              <nav id="navmenu" class="navmenu">
                <ul>
                  <li style="text-align: center !important" class="text-center">
                    <a href="/" class="active text-center">Início</a>
                  </li>
                  <li class="dropdown categorias-container-2">
                    <a href="#">
                      <span>Categorias</span>
                      <i class="bi bi-chevron-down toggle-dropdown"></i>
                    </a>

                    <ul class="category-list m-1">
                      <li
                        v-for="(categoria, i) in categorias"
                        :key="i"
                        style="border-radius: 14px; margin-bottom: 5px"
                        class="cursor-pointer"
                        @click="filterByCategoria(categoria)"
                      >
                        <a class="f" style="padding: 10px 15px; display: block">
                          {{ categoria.nome }}
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown" v-if="servicos.length">
                    <a href="#"
                      ><span>Serviços</span>
                      <i class="bi bi-chevron-down toggle-dropdown"></i
                    ></a>
                    <ul>
                      <li v-for="(servico, i) in servicos" :key="i">
                        <a
                          @click="openServico(servico)"
                          class="cursor-pointer"
                          >{{ servico.titulo }}</a
                        >
                      </li>
                      <!-- <li class="dropdown"><a href="#"><span>Redes Empresariais</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Switches Gerenciáveis</a></li>
                    <li><a href="#">Access Points</a></li>
                    <li><a href="#">Firewalls</a></li>
                    <li><a href="#">Servidores NAS</a></li>
                    <li><a href="#">Controladores WiFi</a></li>
                  </ul>
                </li> -->
                      <!-- <li><a href="#">Redes Domésticas</a></li>
                <li><a href="#">Suporte Técnico</a></li>
                <li><a href="#">Instalação</a></li> -->
                    </ul>
                  </li>

                  <!-- Products Mega Menu 1
            <li class="products-megamenu-1"><a href="#"><span>Produtos</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>

              Products Mega Menu 1 Mobile View
              <ul class="mobile-megamenu">

                <li><a href="#">Produtos em Destaque</a></li>
                <li><a href="#">Lançamentos</a></li>
                <li><a href="#">Promoções</a></li>

                <li class="dropdown"><a href="#"><span>Roteadores</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Roteadores WiFi 6</a></li>
                    <li><a href="#">Roteadores Mesh</a></li>
                    <li><a href="#">Roteadores Gaming</a></li>
                    <li><a href="#">Roteadores 4G/5G</a></li>
                    <li><a href="#">Roteadores Empresariais</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Switches</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Switches Não-Gerenciáveis</a></li>
                    <li><a href="#">Switches Gerenciáveis</a></li>
                    <li><a href="#">Switches PoE</a></li>
                    <li><a href="#">Switches Core</a></li>
                    <li><a href="#">Mini Switches</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Redes WiFi</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Access Points</a></li>
                    <li><a href="#">Repetidores</a></li>
                    <li><a href="#">Adaptadores WiFi</a></li>
                    <li><a href="#">Antenas</a></li>
                    <li><a href="#">Controladores</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Segurança</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Firewalls</a></li>
                    <li><a href="#">VPN</a></li>
                    <li><a href="#">Câmeras IP</a></li>
                    <li><a href="#">NVRs</a></li>
                    <li><a href="#">Controle de Acesso</a></li>
                  </ul>
                </li>

              </ul>End Products Mega Menu 1 Mobile View

              Products Mega Menu 1 Desktop View
              <div class="desktop-megamenu">

                <div class="megamenu-tabs">
                  <ul class="nav nav-tabs" id="productMegaMenuTabs" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="featured-tab" data-bs-toggle="tab" data-bs-target="#featured-content-1862" type="button" aria-selected="true" role="tab">Destaques</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="new-tab" data-bs-toggle="tab" data-bs-target="#new-content-1862" type="button" aria-selected="false" tabindex="-1" role="tab">Lançamentos</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="sale-tab" data-bs-toggle="tab" data-bs-target="#sale-content-1862" type="button" aria-selected="false" tabindex="-1" role="tab">Promoções</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="category-tab" data-bs-toggle="tab" data-bs-target="#category-content-1862" type="button" aria-selected="false" tabindex="-1" role="tab">Categorias</button>
                    </li>
                  </ul>
                </div>

                Tabs Content
                <div class="megamenu-content tab-content">

                  Featured Tab
                  <div class="tab-pane fade show active" id="featured-content-1862" role="tabpanel" aria-labelledby="featured-tab">
                    <div class="product-grid">
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Imagem" loading="lazy">
                        </div>
                        <div class="product-info">
                          <h5>Imagem Pro</h5>
                          <p class="price">R$ 1.299,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Switch PoE" loading="lazy">
                        </div>
                        <div class="product-info">
                          <h5>Switch PoE 24 Portas</h5>
                          <p class="price">R$ 2.499,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Access Point" loading="lazy">
                        </div>
                        <div class="product-info">
                          <h5>Access Point Corporativo</h5>
                          <p class="price">R$ 899,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Firewall" loading="lazy">
                        </div>
                        <div class="product-info">
                          <h5>Firewall UTM</h5>
                          <p class="price">R$ 3.999,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  New Arrivals Tab
                  <div class="tab-pane fade" id="new-content-1862" role="tabpanel" aria-labelledby="new-tab">
                    <div class="product-grid">
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Roteador Mesh" loading="lazy">
                          <span class="badge-new">Novo</span>
                        </div>
                        <div class="product-info">
                          <h5>Sistema Mesh WiFi 6E</h5>
                          <p class="price">R$ 2.999,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Switch 10G" loading="lazy">
                          <span class="badge-new">Novo</span>
                        </div>
                        <div class="product-info">
                          <h5>Switch 10G Enterprise</h5>
                          <p class="price">R$ 4.599,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Câmera IP" loading="lazy">
                          <span class="badge-new">Novo</span>
                        </div>
                        <div class="product-info">
                          <h5>Câmera IP 4K PoE</h5>
                          <p class="price">R$ 799,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="NAS" loading="lazy">
                          <span class="badge-new">Novo</span>
                        </div>
                        <div class="product-info">
                          <h5>Storage NAS 8 Baias</h5>
                          <p class="price">R$ 5.999,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  Sale Tab
                  <div class="tab-pane fade" id="sale-content-1862" role="tabpanel" aria-labelledby="sale-tab">
                    <div class="product-grid">
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Roteador Gaming" loading="lazy">
                          <span class="badge-sale">-30%</span>
                        </div>
                        <div class="product-info">
                          <h5>Roteador Gaming Pro</h5>
                          <p class="price"><span class="original-price">R$ 1.499,99</span> R$ 1.049,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Access Point" loading="lazy">
                          <span class="badge-sale">-25%</span>
                        </div>
                        <div class="product-info">
                          <h5>Access Point WiFi 6</h5>
                          <p class="price"><span class="original-price">R$ 799,99</span> R$ 599,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Switch" loading="lazy">
                          <span class="badge-sale">-40%</span>
                        </div>
                        <div class="product-info">
                          <h5>Switch 8 Portas Gigabit</h5>
                          <p class="price"><span class="original-price">R$ 299,99</span> R$ 179,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                      <div class="product-card">
                        <div class="product-image">
                          <img src="assets/img/example4.png" alt="Repetidor" loading="lazy">
                          <span class="badge-sale">-20%</span>
                        </div>
                        <div class="product-info">
                          <h5>Repetidor WiFi Mesh</h5>
                          <p class="price"><span class="original-price">R$ 399,99</span> R$ 319,99</p>
                          <a href="#" class="btn-view">Ver Produto</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  Categories Tab
                  <div class="tab-pane fade" id="category-content-1862" role="tabpanel" aria-labelledby="category-tab">
                    <div class="category-grid">
                      <div class="category-column">
                        <h4>Roteadores</h4>
                        <ul>
                          <li><a href="#">WiFi 6</a></li>
                          <li><a href="#">Mesh</a></li>
                          <li><a href="#">Gaming</a></li>
                          <li><a href="#">4G/5G</a></li>
                          <li><a href="#">Empresariais</a></li>
                        </ul>
                      </div>
                      <div class="category-column">
                        <h4>Switches</h4>
                        <ul>
                          <li><a href="#">Não-Gerenciáveis</a></li>
                          <li><a href="#">Gerenciáveis</a></li>
                          <li><a href="#">PoE</a></li>
                          <li><a href="#">10G/40G</a></li>
                          <li><a href="#">Core</a></li>
                        </ul>
                      </div>
                      <div class="category-column">
                        <h4>Redes WiFi</h4>
                        <ul>
                          <li><a href="#">Access Points</a></li>
                          <li><a href="#">Controladores</a></li>
                          <li><a href="#">Antenas</a></li>
                          <li><a href="#">Repetidores</a></li>
                          <li><a href="#">Adaptadores</a></li>
                        </ul>
                      </div>
                      <div class="category-column">
                        <h4>Segurança</h4>
                        <ul>
                          <li><a href="#">Firewalls</a></li>
                          <li><a href="#">VPN</a></li>
                          <li><a href="#">Câmeras IP</a></li>
                          <li><a href="#">NVRs</a></li>
                          <li><a href="#">Controle de Acesso</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </li>End Products Mega Menu 1 -->

                  <!-- Products Mega Menu 2
            <li class="products-megamenu-2"><a href="#"><span>Categorias</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>

              Products Mega Menu 2 Mobile View
              <ul class="mobile-megamenu">

                <li><a href="#">Residencial</a></li>
                <li><a href="#">Empresarial</a></li>
                <li><a href="#">Provedores</a></li>

                <li class="dropdown"><a href="#"><span>Redes WiFi</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">WiFi 6/6E</a></li>
                    <li><a href="#">Mesh</a></li>
                    <li><a href="#">Outdoor</a></li>
                    <li><a href="#">Corporativo</a></li>
                    <li><a href="#">Hotspot</a></li>
                    <li><a href="#">Guest Network</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Infraestrutura</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Cabeamento</a></li>
                    <li><a href="#">Racks</a></li>
                    <li><a href="#">UPS</a></li>
                    <li><a href="#">PDUs</a></li>
                    <li><a href="#">Patch Panels</a></li>
                    <li><a href="#">Organizadores</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Segurança</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">UTM</a></li>
                    <li><a href="#">VPN</a></li>
                    <li><a href="#">IPS/IDS</a></li>
                    <li><a href="#">CFTV IP</a></li>
                    <li><a href="#">Controle de Acesso</a></li>
                    <li><a href="#">Monitoramento</a></li>
                  </ul>
                </li>

                <li class="dropdown"><a href="#"><span>Serviços</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                  <ul>
                    <li><a href="#">Consultoria</a></li>
                    <li><a href="#">Instalação</a></li>
                    <li><a href="#">Configuração</a></li>
                    <li><a href="#">Manutenção</a></li>
                  </ul>
                </li>

              </ul>End Products Mega Menu 2 Mobile View

              Products Mega Menu 2 Desktop View
              <div class="desktop-megamenu">

                <div class="megamenu-tabs">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link active" id="womens-tab" data-bs-toggle="tab" data-bs-target="#womens-content-1883" type="button" aria-selected="true" role="tab">RESIDENCIAL</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="mens-tab" data-bs-toggle="tab" data-bs-target="#mens-content-1883" type="button" aria-selected="false" tabindex="-1" role="tab">EMPRESARIAL</button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" id="kids-tab" data-bs-toggle="tab" data-bs-target="#kids-content-1883" type="button" aria-selected="false" tabindex="-1" role="tab">PROVEDORES</button>
                    </li>
                  </ul>
                </div>

                Tabs Content
                <div class="megamenu-content tab-content">

                  Residencial Tab
                  <div class="tab-pane fade show active" id="womens-content-1883" role="tabpanel" aria-labelledby="womens-tab">
                    <div class="category-layout">
                      <div class="categories-section">
                        <div class="category-headers">
                          <h4>WiFi</h4>
                          <h4>Conectividade</h4>
                          <h4>Segurança</h4>
                          <h4>Serviços</h4>
                        </div>

                        <div class="category-links">
                          <div class="link-row">
                            <a href="#">Roteadores WiFi 6</a>
                            <a href="#">Switches</a>
                            <a href="#">Câmeras IP</a>
                            <a href="#">Instalação</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Sistemas Mesh</a>
                            <a href="#">Powerline</a>
                            <a href="#">Sensores</a>
                            <a href="#">Configuração</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Repetidores</a>
                            <a href="#">Adaptadores</a>
                            <a href="#">Alarmes</a>
                            <a href="#">Suporte</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Antenas</a>
                            <a href="#">Cabos</a>
                            <a href="#">Fechaduras</a>
                            <a href="#">Manutenção</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Access Points</a>
                            <a href="#">Acessórios</a>
                            <a href="#">Interfones</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">Controladores</a>
                            <a href="#">Storage</a>
                            <a href="#">Automação</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#"></a>
                          </div>
                        </div>
                      </div>
                      <div class="featured-section">
                        <div class="featured-image">
                          <img src="assets/img/product/example3.png" alt="Sistema Mesh WiFi 6">
                          <div class="featured-content">
                            <h3>Sistema<br>Mesh<br>WiFi 6</h3>
                            <h3>Sistema<br>Mesh<br>WiFi 6</h3>
                            <a href="#" class="btn-shop">Comprar agora</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  Redes Empresariais
                  <div class="tab-pane fade" id="mens-content-1883" role="tabpanel" aria-labelledby="mens-tab">
                    <div class="category-layout">
                      <div class="categories-section">
                        <div class="category-headers">
                          <h4>Roteadores</h4>
                          <h4>Switches</h4>
                          <h4>Acessórios</h4>
                          <h4>Serviços</h4>
                        </div>

                        <div class="category-links">
                          <div class="link-row">
                            <a href="#">WiFi 6</a>
                            <a href="#">Gerenciáveis</a>
                            <a href="#">Antenas</a>
                            <a href="#">Instalação</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Mesh</a>
                            <a href="#">PoE</a>
                            <a href="#">Cabos</a>
                            <a href="#">Configuração</a>
                          </div>
                          <div class="link-row">
                            <a href="#">4G/5G</a>
                            <a href="#">Core</a>
                            <a href="#">SFPs</a>
                            <a href="#">Suporte</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Gaming</a>
                            <a href="#">Mini Switches</a>
                            <a href="#">Racks</a>
                            <a href="#">Manutenção</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Empresariais</a>
                            <a href="#">Industriais</a>
                            <a href="#">Ferramentas</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">VPN</a>
                            <a href="#">Não-Gerenciáveis</a>
                            <a href="#">Cases</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#"></a>
                          </div>
                        </div>
                      </div>
                      <div class="featured-section">
                        <div class="featured-image">
                          <img src="assets/img/product/example3.png" alt="Switches Empresariais">
                          <div class="featured-content">
                            <h3>Switches<br>Empresariais<br>10G</h3>
                            <a href="#" class="btn-shop">Comprar agora</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  Redes Domésticas
                  <div class="tab-pane fade" id="kids-content-1883" role="tabpanel" aria-labelledby="kids-tab">
                    <div class="category-layout">
                      <div class="categories-section">
                        <div class="category-headers">
                          <h4>WiFi</h4>
                          <h4>Conectividade</h4>
                          <h4>Acessórios</h4>
                          <h4>Por Ambiente</h4>
                        </div>

                        <div class="category-links">
                          <div class="link-row">
                            <a href="#">Roteadores</a>
                            <a href="#">Switches</a>
                            <a href="#">Antenas</a>
                            <a href="#">Casa Pequena</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Mesh</a>
                            <a href="#">Powerline</a>
                            <a href="#">Cabos</a>
                            <a href="#">Casa Média</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Repetidores</a>
                            <a href="#">Adaptadores</a>
                            <a href="#">Conectores</a>
                            <a href="#">Casa Grande</a>
                          </div>
                          <div class="link-row">
                            <a href="#">Access Points</a>
                            <a href="#">Mini Switches</a>
                            <a href="#">Protetores</a>
                            <a href="#">Apartamento</a>
                          </div>
                          <div class="link-row">
                            <a href="#">4G/5G</a>
                            <a href="#">Hub USB</a>
                            <a href="#">Cases</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">Gaming</a>
                            <a href="#">Storage</a>
                            <a href="#">Ferramentas</a>
                            <a href="#"></a>
                          </div>
                          <div class="link-row">
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#">Ver todos</a>
                            <a href="#"></a>
                          </div>
                        </div>
                      </div>
                      <div class="featured-section">
                        <div class="featured-image">
                          <img src="assets/img/example4.png" alt="Novos Produtos">
                          <div class="featured-content">
                            <h3>Novos<br>Produtos<br>WiFi 6</h3>
                            <a href="#" class="btn-shop">Comprar agora</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>End Products Mega Menu 2 Desktop View

            </li>End Products Mega Menu 2 -->

                  <!-- <li><a href="category.html">Categorias</a></li>
            <li><a href="product-details.html">Detalhes do Produto</a></li>
            <li><a href="cart.html">Carrinho</a></li> -->
                  <!-- <li><a href="checkout.html">Checkout</a></li> -->

                  <li v-for="pagina in paginasInstitucionaisVisiveis" :key="pagina.id">
                    <a
                      :href="'/' + pagina.slug"
                      @click.prevent="$router.push('/' + pagina.slug)"
                      >{{ pagina.title }}</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <form
            v-if="false"
            class="search-form desktop-search-form"
            @submit.prevent="searchProducts"
          >
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Buscar produtos"
                v-model="searchGlobal"
                @keyup.enter="searchProducts"
              />
              <button class="btn" type="submit" @click="searchProducts">
                <i class="bi bi-search"></i>
              </button>
            </div>
          </form>

          <!-- Actions -->
          <div
            class="header-actions d-flex align-items-center justify-content-end"
          >
            <!-- Mobile Search Toggle -->
            <!-- <button
              class="header-action-btn mobile-search-toggle d-xl-none"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mobileSearch"
              aria-expanded="false"
              aria-controls="mobileSearch"
            >
              <i class="bi bi-search"></i>
            </button> -->

            <!-- ThemeSwitcher -->
            <a class="d-none d-md-block">
              <ThemeSwitcher />
            </a>

            <!-- Account -->
            <div class="dropdown account-dropdown" style="display:flex;align-items:center;">
              <button
                @click="openMenuMobile()"
                class="header-action-btn button-header-action-- text-muted mobile-header-btn"
                data-bs-toggle="dropdown"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-user-icon lucide-user"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
              <AccountMenu />
            </div>


            <!-- Account -->
            <div
              class="dropdown account-dropdown"
              style="display:flex;align-items:center;"
            >
              <button
                class="header-action-btn button-header-action-- text-muted mobile-header-btn"
                @click="$router.push('/cart')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-shopping-cart-icon lucide-shopping-cart"
                >
                  <circle cx="8" cy="21" r="1" />
                  <circle cx="19" cy="21" r="1" />
                  <path
                    d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                  />
                </svg>
                <span
                  class="badge text-dark mx3-cart-badge-text"
                  v-if="$store.state.carrinho.length"
                  >{{ $store.state.carrinho.length }}</span
                >
              </button>
            </div>

            <!-- Mobile Navigation Toggle -->
            <!-- <i class="mobile-nav-toggle d-xl-none bi bi-list me-0" @click="$util.redirectTo('/')  "></i> -->
          </div>

        </div>

        <!-- Busca + Ordenar em faixa própria, ABAIXO da faixa da
             logomarca/botões (pedido: no mobile o campo de busca não
             aparecia porque estava dentro da linha flex "nowrap" da
             logomarca, sendo esmagado pelos botões até sumir da tela;
             agora ocupa uma faixa inteira, em largura total, abaixo dela).
             "Ordenar por" continua embutido como ícone do lado direito,
             dentro do próprio campo de busca. -->
        <div class="header-search-sort-mobile">
          <i class="bi bi-search header-search-icon"></i>
          <input
            type="text"
            class="header-search-input-mobile"
            placeholder="Buscar produtos..."
            v-model="searchGlobal"
            @input="onSearchInput"
            @keyup.enter="applyHeaderFilters"
          />
          <i class="bi bi-sliders header-sort-icon-visual" aria-hidden="true"></i>
          <select
            class="header-sort-select-overlay"
            v-model="orderByGlobal"
            @change="applyHeaderFilters"
            aria-label="Ordenar por"
          >
            <option value="estoque">Ordenar por</option>
            <option value="nome">A a Z</option>
            <option value="valor">Menor Valor</option>
            <option value="valor+">Maior Valor</option>
            <option value="maisvendidos">Mais vendidos</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Mobile Search Form -->
    <div class="collapse" id="mobileSearch">
      <div class="container">
        <form class="search-form" @submit.prevent="searchProducts">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar produtos"
              v-model="searchGlobal"
              @keyup.enter="searchProducts"
            />
            <button class="btn" type="submit" @click="searchProducts">
              <i class="bi bi-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
import Login from "@/pages/Login.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import templateMixin from "../mixins/templateMixin";
import ModalOpcaoInstitucional from "./ModalOpcaoInstitucional.vue";
import ModalCategoriaFiltroMobile from "./ModalCategoriaFiltroMobile";

export default {
  name: "Header",
  mixins: [templateMixin],
  components: {
    ThemeSwitcher,
    ModalCategoriaFiltroMobile,
    ModalOpcaoInstitucional,
  },
  data() {
    return {
      searchGlobal: "",
      orderByGlobal: "valor+",
      categorias: [],
      servicos: [],
      paginasInstitucionais: [],
      searchDebounce: null,
    };
  },
  created() {
    this.$api.get("servico/").then((res) => {
      this.servicos = Array.isArray(res.data) ? res.data : [];
      this.$forceUpdate();
    }).catch(() => { this.servicos = []; });
    // Carrega páginas institucionais do gerenciador de produtos via API
    // (mesma fonte de dados usada pelo cabeçalho desktop)
    const syncUrl = window.location.origin + "/api/sync_institutional_pages.php?action=get_all";
    fetch(syncUrl)
      .then((r) => r.json())
      .then((res) => {
        if (res.status === "success" && res.pages) {
          this.paginasInstitucionais = res.pages;
        }
      })
      .catch((err) => console.error("Erro ao carregar menu institucional:", err));
  },
  mounted() {
    // Inicializa as funcionalidades específicas do header
    this.initMobileNav();
    this.initMobileDropdowns();
    this.initSwiper();
    // Cabeçalho fixo: reserva no <main> a altura exata do cabeçalho
    // (recalculada ao redimensionar) para o conteúdo não ficar escondido
    // atrás dele. Em telas de desktop o componente fica display:none -
    // a altura medida é 0 e nenhum padding é aplicado.
    this.aplicarHeaderFixo();
    window.addEventListener('resize', this.aplicarHeaderFixo);
    window.addEventListener('load', this.aplicarHeaderFixo);
    this.$nextTick(() => this.aplicarHeaderFixo());
    if (typeof ResizeObserver !== 'undefined') {
      this._headerFixoResizeObserver = new ResizeObserver(() => {
        this.aplicarHeaderFixo();
      });
      this._headerFixoResizeObserver.observe(this.$el);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!this._isDestroyed) this.aplicarHeaderFixo();
      });
    }
    setTimeout(() => {
      this.searchGlobal = this.$route?.query?.q ?? "";
      this.orderByGlobal = this.$route?.query?.ordenar ?? "valor+";
      this.getCategorias();
    }, 500);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.aplicarHeaderFixo);
    window.removeEventListener('load', this.aplicarHeaderFixo);
    if (this._headerFixoResizeObserver) {
      this._headerFixoResizeObserver.disconnect();
    }
    this.removerHeaderFixo();
  },
  computed: {
    paginasInstitucionaisVisiveis() {
      // Páginas que pertencem exclusivamente ao rodapé (Termos, Privacidade e Cookies)
      // não devem ser exibidas no menu do cabeçalho.
      const slugsExclusivosRodape = ['termos', 'privacidade', 'cookies'];
      return this.paginasInstitucionais.filter(
        (p) =>
          (p.status === 'published' || !p.status) &&
          !slugsExclusivosRodape.includes(p.slug)
      );
    },
  },
  methods: {
    // Cabeçalho fixo (ver comentário da regra .header-mobile-- no CSS):
    // transfere para o <main> a altura medida do cabeçalho como
    // padding-top - inclui a faixa da logomarca/botões E a faixa do
    // campo "Buscar produtos...".
    aplicarHeaderFixo() {
      const main = document.querySelector('#app > main');
      if (!main) return;
      // Mede a caixa efetivamente renderizada (incluindo frações de pixel),
      // em vez do valor inteiro que pode ficar desatualizado após F5/zoom.
      const altura = this.$el
        ? Math.ceil(this.$el.getBoundingClientRect().height)
        : 0;
      // setProperty com "important": o App.vue define main { padding: 0
      // !important } - um style.paddingTop simples seria vencido por ele.
      if (altura > 0) {
        main.style.setProperty('padding-top', altura + 'px', 'important');
      } else {
        main.style.setProperty('padding-top', '0px', 'important');
      }
    },
    removerHeaderFixo() {
      const main = document.querySelector('#app > main');
      if (main) main.style.removeProperty('padding-top');
    },
    openMenuMobile() {
      // Antes, tocar no ícone de login no mobile sempre navegava para a
      // página /login (mesmo com o dropdown do AccountMenu já disponível).
      // Agora, se não estiver logado, deixa o próprio dropdown (com o
      // formulário de login embutido) abrir normalmente - igual no
      // desktop. Logado, continua indo direto para "Meus Pedidos".
      if (this.$util.clienteLogado()) {
        this.$router.push({ name: "Orders" });
      }
    },
    openServico(servico) {
      window.open(`/service?id=${servico.id}`, "_self");
    },
    filterByCategoria(categoria) {
      localStorage.setItem("filterCategoria", JSON.stringify(categoria));
      this.$router.push({
        path: '/products',
        query: { categoria: categoria?.id ?? categoria }
      });
    },

    getCategorias() {
      console.log("pegando categorias", this.$api);
      this.$api.getCategorias().then((res) => {
        this.categorias = res.data;

        this.$store.state.categoriasProdutos = {};
        for (const categoria of this.categorias) {
          this.$store.state.categoriasProdutos[categoria.id] = categoria;
        }
      });
    },
    searchProducts() {
      let url = `/products`;

      if (this.searchGlobal) {
        url = `/products?q=${this.searchGlobal}`;
      }

      localStorage.removeItem("filterCategoria");

      window.location.href = url;
      // window.location.reload();
    },
    // Campo de busca + ordenação mesclados no cabeçalho (mesma lógica do
    // Header.vue desktop). Atualizam a query da rota: se já estiver em
    // /products, o Products.vue reage via seu watcher de $route; caso
    // contrário, navega para lá com os filtros aplicados.
    onSearchInput() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.applyHeaderFilters(), 400);
    },
    applyHeaderFilters() {
      const query = { ...this.$route.query };
      if (this.searchGlobal) {
        query.q = this.searchGlobal;
      } else {
        delete query.q;
      }
      if (this.orderByGlobal && this.orderByGlobal !== "estoque") {
        query.ordenar = this.orderByGlobal;
      } else {
        delete query.ordenar;
      }
      localStorage.removeItem("filterCategoria");
      if (this.$route.name === "products") {
        this.$router.push({ query }).catch(() => {});
      } else {
        this.$router.push({ path: "/products", query }).catch(() => {});
      }
    },
  },
};
</script>


<style lang="scss">
.header-mobile-- {
  .logo-site-img {
    height: 46px !important;
    /* largura automática: antes era forçada em 210px, o que "esticava" a
       logomarca horizontalmente (a imagem natural é 986x549); com width
       auto a proporção original é mantida. */
    width: auto !important;
  }
}

.header-action-btn {
  border-radius: 10px !important;
  width: 65px !important;
  height: 65px !important;
  text-align: center !important;
  /* Cor da borda vem do tema ativo (a borda branca translúcida era
     invisível no tema claro). */
  border: 0.1px solid var(--mx3-style-border, #ffffff1a) !important;
}

.header-action-btn .badge {
  position: absolute;
  top: 2px;
  right: 2px;
  color: rgb(255, 255, 255);
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  text-align: center;
  background: linear-gradient(135deg, rgb(255, 102, 0), rgb(201, 86, 10));
  border-radius: 10px;
  padding: 2px 6px;
}
.header-action-btn .badge:hover {
  color: var(--primary) !important;
}

.navmenu a {
  font-weight: 600 !important;
}

.navmenu a {
  font-weight: 600;
  color: #374866;
  transition: all 0.3s ease;
  position: relative;
}

/* .navmenu a:before {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--mx3-style-primary, #ff6600);
  transform: scaleX(0);
  transition: transform 0.3s ease;
} */

.navmenu a.active:before,
.navmenu a:hover:before {
  transform: scaleX(1);
}

.navmenu a.active,
.navmenu a:hover {
  color: var(--mx3-style-primary, #ff6600);
}
.navmenu .dropdown ul {
  background: var(--mx3-style-bg-card, #1c1e20) !important;
  border-radius: 15px !important;
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.navmenu .dropdown ul li {
  margin-left: 5px;
  transition: all 1s ease;
}
.navmenu .dropdown ul li:hover {
  margin-left: 15px;
  transition: all 1s ease;
}
</style>

<style scoped lang="scss">
/* Campo de busca + ordenação mesclados (linha própria, abaixo da logo, no
   cabeçalho mobile) - mesmo padrão/variáveis de tema usados no cabeçalho
   desktop (Header.vue > .header-search-sort), só que ocupando a largura
   total da linha em vez de um max-width fixo. */
.header-search-sort-mobile {
  position: relative;
  display: flex;
  align-items: center;
  width: auto;
  gap: 8px;
  /* Ocupa a área horizontal toda (margens negativas compensam o respiro
     lateral do container, alinhando as bordas com a seção de garantias
     logo abaixo) e fica mais baixa (30px) para um visual mais elegante. */
  margin: 2px -16px 8px;
  padding: 0 40px 0 14px;
  border: 1px solid var(--mx3-style-primary, #ff6600);
  border-radius: 17px;
  background: var(--mx3-style-bg-card, #1c1e20);
  height: 30px;
  box-sizing: border-box;
}

.header-search-sort-mobile .header-search-icon {
  flex: 0 0 auto;
  color: var(--mx3-style-text-muted, rgba(255, 255, 255, 0.5));
  font-size: 0.9rem;
}

.header-search-input-mobile {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--mx3-style-text-primary, #fff);
  /* 16px: com o zoom por "pinça" liberado no viewport, o iOS Safari dá
     auto-zoom ao focar inputs com fonte menor que 16px - 16px mantém o
     foco na mesma escala, sem dar "salto" na página. */
  font-size: 16px;
  outline: none;
}

.header-search-input-mobile::placeholder {
  color: var(--mx3-style-text-muted, rgba(255, 255, 255, 0.45));
}

.header-search-sort-mobile .header-sort-icon-visual {
  position: absolute;
  top: 50%;
  right: 14px;
  color: var(--mx3-sort-icon-color, var(--mx3-style-primary, #ff6600));
  font-size: 0.95rem;
  line-height: 1;
  pointer-events: none;
  transform: translateY(-50%);
}

/* O <select> real fica invisível, sobreposto exatamente sobre o ícone
   acima - continua 100% funcional, só que visualmente parece um ícone
   dentro do campo de busca (mesmo truque do cabeçalho desktop). Sem isto,
   o navegador renderiza o <select> normalmente, como um segundo campo
   visível abaixo da busca. */
.header-search-sort-mobile .header-sort-select-overlay {
  position: absolute;
  top: 0;
  right: 0;
  width: 34px;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  opacity: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

/* Lista de opções do "Ordenar por" (aberta pelo navegador/SO ao clicar):
   fundo e texto agora usam variáveis dedicadas (--mx3-sort-menu-bg /
   --mx3-sort-menu-text), com campos próprios na tela "Personalizar
   E-commerce" - mesma variável usada na versão desktop (Header.vue), o
   que garante que o ajuste feito lá vale igual no celular. */
.header-sort-select-overlay,
.header-sort-select-overlay option {
  color: var(--mx3-sort-menu-text, #000000);
  background-color: var(--mx3-sort-menu-bg, var(--mx3-style-primary, #ff6600));
}

.categorias-container-2 {
  li {
    background-color: #afafaf !important;
  }
  .bg-white:not(.is-active) {
    background-color: white !important;
    border: solid #afafaf60 0.1px !important;
    color: black !important;
  }
  li:not(.is-active) {
    background: var(--mx3-style-bg-card, #1c1e20) !important;
    border: 0.5px solid #e5e5e520 !important;
    span {
      color: #e5e5e5 !important;
    }
  }
  li:not(.is-active):hover {
    background: var(--mx3-style-bg-card, #1c1e20) !important;
    border: 0.5px solid var(--mx3-style-primary, #ff6600) !important;
    span {
      padding-left: 15px !important;
      text-shadow: 2px 2px 15px black !important;
      color: var(--mx3-style-primary, #ff6600) !important;

      transition: all 0.3s ease;
    }
  }
  .is-active {
    background: transparent !important;
    border: 0.5px solid var(--mx3-style-primary, #ff6600) !important;
    span {
      text-shadow: 5px 5px 15px black !important;
      color: var(--mx3-style-primary, #ff6600) !important;
    }
  }
  /*.input-rounded-class*/
  .input-rounded-class {
    border-radius: 14px !important;
    border-top-right-radius: 14px !important;
    border-bottom-right-radius: 14px !important;
    background: var(--mx3-style-input-bg, #232628) !important;
    background-color: var(--mx3-style-input-bg, #232628) !important;
  }
  /*.input-rounded-class*/
  .button-rounded-class {
    border-top-left-radius: 14px !important;
    border-bottom-left-radius: 14px !important;
    border-radius: 14px !important;
    padding-right: 12px !important;
    height: 35px !important;
    scale: 0.9 !important;
    margin-top: 1px !important;
    right: 47px !important;
    position: relative !important;
  }
  /*.input-rounded-class*/
  .input-rounded-class2 {
    background: var(--mx3-style-input-bg, #232628) !important;
    background-color: var(--mx3-style-input-bg, #232628) !important;
    border-radius: 14px !important;
    /* border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-right:14px; */
  }

  /* Estilos mantidos, apenas para contexto */
  .cursor-pointer {
    cursor: pointer !important;
  }

  /* --- Estilos para os Filtros Laterais --- */

  .filter-group {
    padding: 10px !important;
    border-radius: 8px !important;
  }

  .filter-title {
    font-size: 1.1rem !important;
    font-weight: bold !important;
    color: #343a40 !important;
    border-bottom: 1px solid #eee !important;
    padding-bottom: 5px !important;
  }

  .category-list {
    padding-left: 0 !important;
  }

  .filter-item:hover {
    margin-left: 5px !important;
    transition: all 0.3s ease !important;
  }

  .filter-item {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 8px 10px !important;
    margin-bottom: 3px !important;
    border-radius: 5px !important;
    transition: background-color 0.2s, color 0.2s !important;
    font-size: 0.95rem !important;
    color: #555 !important;
  }

  .filter-item:hover:not(.is-active) {
    background-color: #f0f0f020 !important;
    color: #333 !important;
  }

  .filter-item.is-active {
    background-color: var(--primary) !important;
    color: white !important;
    font-weight: bold !important;
  }

  .subcategory-list .filter-item,
  .product-filter-list .filter-item {
    /* Estilo similar para o novo filtro */
    padding-left: 20px !important;
    font-size: 0.9rem !important;
  }

  /* --- Esconder/Mostrar elementos para desktop e mobile --- */
  @media (max-width: 767.98px) {
    .hide-on-mobile {
      display: none !important;
    }
    .show-on-mobile {
      display: block !important;
    }
  }

  @media (min-width: 768px) {
    .show-on-mobile {
      display: none !important;
    }
  }

  #products-container-custom {
    max-width: 80% !important;
  }
  #produto-item- {
    max-width: 300px !important;
    min-width: 280px !important;
  }

  @media (max-width: 768px) {
    #products-container-custom {
      width: 100% !important;
      max-width: 100% !important;
    }
    #produto-item- {
      width: 50% !important;
      max-width: unset !important;
      min-width: unset !important;
      scale: 0.9 !important;
      padding: 0.1px !important;
    }
    #produto-item- > div {
      margin: 1px !important;
    }
    #produto-item- > button > small {
      font-size: 5px !important;
    }
  }
  .filtro-text-color {
    color: black !important;
  }
  .category-name {
    padding: 10px !important;
    color: #ffffff50 !important;
  }
  .category-name:hover {
    padding: 10px !important;
  }
  .form-control {
    border: 1px solid #afafaf40 !important;
  }
  .form-control:focus {
    border: var(--mx3-style-primary, #ff6600) solid 2px !important;
    box-shadow: unset !important;
  }
}
#header .main-header {
  border-bottom: transparent !important;
  padding: 4px 0 !important;
  min-height: auto !important;
  height: auto !important;
}

.button-header-action-- {
  width: 40px !important;
  height: 40px !important;
  transition: transform 0.2s ease !important;
  padding: 0 !important;
  min-width: 40px !important;
  min-height: 40px !important;
}

.button-header-action--:hover {
  transform: translateY(-2px) !important;

  /* Cor de fundo do hover vinda do tema ativo (o hex fixo #101214 do
     tema escuro virava um blocão escuro no tema claro). */
  background: var(--mx3-style-bg-card-hover, #101214) !important;
  border: var(--mx3-style-primary, #ff6600) solid 0.5px !important;
}

.scale-min-- {
  scale: 0.7;
}

/* Mobile: botões Login e Carrinho alinhados verticalmente com o texto Institucional */
@media (max-width: 1199px) {
  .mobile-header-btn {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    min-height: 36px !important;
    padding: 0 !important;
    margin: 0 !important;
    scale: 1 !important;
    margin-top: 2px !important;
  }
  .header-actions {
    align-items: center !important;
    gap: 2px !important;
    margin-top: -2px !important;
    /* Blindagem contra regra global vazada de outra página
       (".header-actions { width: 100%; margin: ... }" em media query de
       páginas como Pedidos/Perfil), que esticava esta caixa para a largura
       toda da linha e jogava os botões de login/carrinho para fora da
       tela no mobile. */
    width: auto !important;
    margin-left: auto !important;
    flex: 0 0 auto !important;
    justify-content: flex-end !important;
  }

  /* Ícones dos botões de login/carrinho no MESMO tamanho dos ícones dos
     botões hambúrguer e Institucional do lado esquerdo (16px) - antes
     estavam em 24px, visivelmente maiores. */
  .header-actions .mobile-header-btn svg {
    width: 16px !important;
    height: 16px !important;
  }
  .account-dropdown {
    margin-top: 2px !important;
    margin-right: 0 !important;
  }
}

/* Linha do cabeçalho mobile: hambúrguer + Institucional (esquerda) - logo
   centralizada de verdade (não só "no meio do espaço sobrando") - login +
   carrinho (direita).
   Usa flex (não grid): a linha tem outros elementos "invisíveis" no meio
   do DOM entre a logo e os botões de ação (o componente do modal
   institucional, o menu de navegação legado, um form desativado) - com
   grid de colunas, esses elementos extras podem criar uma coluna/linha
   implícita e empurrar os botões de login/carrinho para uma segunda
   linha, que foi exatamente o bug visto. Com flex + nowrap eles só ficam
   "vazios" no meio sem quebrar o layout, e a logo é retirada do fluxo via
   position:absolute + centralização exata, imune a qualquer vizinho
   extra. */
.mobile-header-row {
  position: relative;
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
  justify-content: space-between;
  min-height: 46px;
}

.mobile-header-left {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
}

.mobile-header-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.header-actions {
  flex: 0 0 auto;
  margin-left: auto;
}

/* O antigo menu de navegação completo (Início/Categorias/Serviços/
   Institucional) embutido nesta linha não tem mais nenhum botão visível
   que o abra no mobile (o hambúrguer agora abre só o modal de
   categorias, e o Institucional abre o próprio modal institucional) -
   por isso fica oculto, sem ocupar espaço na linha. */
.header-nav {
  display: none !important;
}

/* Em telas bem estreitas, com 2 botões de cada lado (hambúrguer+
   Institucional / login+carrinho), a logo poderia encostar nos botões;
   reduz um pouco a altura só nesse caso (largura sempre automática,
   mantendo a proporção). */
@media (max-width: 380px) {
  .mobile-header-logo .logo-site-img {
    height: 40px !important;
    width: auto !important;
  }
}

/* Cabeçalho mobile FIXO ao rolar (pedido): o cabeçalho completo - faixa
   da logomarca/botões + faixa do campo "Buscar produtos..." - permanece
   parado no topo da tela enquanto o conteúdo rola por baixo. Usamos
   position:fixed (e não sticky) porque o overflow-x:hidden do
   html/body (anti-scroll horizontal) faz do body um container de scroll
   que nunca rola - o sticky "grudaria" num container parado e sairia da
   tela junto com o conteúdo. A altura reservada no <main> para o
   cabeçalho não encostar no conteúdo é aplicada via JS (aplicarHeader-
   Fixo), medida dinamicamente. */
.header-mobile-- {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
}

</style>
